import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";
import { ArrowBack } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
import { productActions } from "../../store/actions"; //Acciones para redux
import {
  Alert,
  CustomLoadingOverlay,
  Buttons,
  InputField,
} from "../../components";
import { useTranslation } from "react-i18next";
import { fileRequests } from "../../services";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PreRegForm() {
  const [open, setOpen] = React.useState(false);
  const formMethods = useForm();
  const { useState, useEffect } = React; //Hook para el state
  const navigate = useNavigate(); //Módulo "History" de react router
  const [loadView, setLoadView] = useState(false);
  const [ctrlsDefinitions, setCtrlsDefinitions] = useState([]);
  const file = useSelector((state) => state.FileByGUID);

  //Estados de componente
  const [productId, setProductId] = useState(0);
  const product = useSelector((state) => state.ProductRemote);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(productActions.ProductsRemote());
    setCtrlsDefinitions([]);
  }, []);

  useEffect(() => {
    setLoadView(product.loading);
    if (product.items && product.items.length > 0) {
      console.log("Procto definicion:***************** ", product);
      const controlls = product.items.find(
        (res) => res.Name === "PreRegistro Postulación"
      );
      setProductId(controlls.Id);
      setCtrlsDefinitions(controlls.QuestionDefinitions);
    }
  }, [product]);

  let submitRegister = async (formData) => {
    console.log("Register:************ ", formData);
    if (productId <= 0) {
      Alert({
        icon: "error",
        text: "No se encontro un producto activo.",
        okbtntext: t("general_accept"),
      });
      return;
    }

    try {
      setLoadView(true);
      let newListMetdata = [];
      ctrlsDefinitions.forEach((itemMetadata, i) => {
        if (itemMetadata.Name == "Primer Nombre") {
          newListMetdata.push({
            GroupName: itemMetadata.QuestionGroup,
            Name: "Name",
            Value: formData[itemMetadata.Name],
          });
        } else if (itemMetadata.Name == "Segundo Nombre") {
          newListMetdata.push({
            GroupName: itemMetadata.QuestionGroup,
            Name: "SecondName",
            Value: formData[itemMetadata.Name],
          });
        } else if (itemMetadata.Name == "Primer Apellido") {
          newListMetdata.push({
            GroupName: itemMetadata.QuestionGroup,
            Name: "FatherLastName",
            Value: formData[itemMetadata.Name],
          });
        } else if (itemMetadata.Name == "Segundo Apellido") {
          newListMetdata.push({
            GroupName: itemMetadata.QuestionGroup,
            Name: "MotherLastName",
            Value: formData[itemMetadata.Name],
          });
        } else if (itemMetadata.Name == "Correo electrónico") {
          newListMetdata.push({
            GroupName: itemMetadata.QuestionGroup,
            Name: "Email",
            Value: formData[itemMetadata.Name],
          });
        } else if (itemMetadata.Name == "Teléfono de Contacto") {
          newListMetdata.push({
            GroupName: itemMetadata.QuestionGroup,
            Name: "PhoneNumber",
            Value: formData[itemMetadata.Name],
          });
        } else if (itemMetadata.Name == "Teléfono") {
          newListMetdata.push({
            GroupName: itemMetadata.QuestionGroup,
            Name: "PhoneNumber",
            Value: formData[itemMetadata.Name],
          });
        } else {
          newListMetdata.push({
            GroupName: itemMetadata.QuestionGroup,
            Name: itemMetadata.Name,
            Value:
              formData[itemMetadata.Name]?.Option ||
              formData[itemMetadata.Name],
          });
        }
      });

      // const metadataSolicitud = ctrlsDefinitions.map((item) => ({
      //   Name: item.Name,
      //   Value: formData[item.Name]?.Option || formData[item.Name],
      //   GroupName: item.QuestionGroup,
      // }));

      let dataRequest = {
        WorkFlow_Id: file.items?.ProductId,
        OriginApp: "pwa",
        Metadata: newListMetdata,
        ParentFile_Id: file.items?.Id,
      };

      console.log(dataRequest);
      await fileRequests.GenerateFolioChildWorkflow(dataRequest);
      setLoadView(false);
      Alert(
        {
          icon: "success",
          text: t("success_register_text"),
          okbtntext: t("general_accept"),
        },
        () => navigate("/")
      );
    } catch (error) {
      setLoadView(false);
      Alert({
        icon: "error",
        text: error.message,
        okbtntext: t("general_accept"),
      });
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Button
        variant="contained"
        disabled={
          file.items?.Metadata?.some(
            (func) =>
              func.Name === "EnabledRegisterVacante" && func.Value === "0"
          )
            ? true
            : false
        }
        onClick={handleClickOpen}
      >
        {t("apply_to_text")}
      </Button>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <Box sx={{ backgroundColor: "#f1f1f1" }}>
          <Container maxWidth="md" sx={{ bgcolor: "#fff" }}>
            <DialogTitle sx={{ py: 1 }}>
              <IconButton edge="start" color="primary" onClick={handleClose}>
                <ArrowBack />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <FormProvider {...formMethods}>
                {loadView ? (
                  <CustomLoadingOverlay
                    active={loadView}
                    text={t("general_loading_message")}
                  />
                ) : null}

                <Typography variant="h6" gutterBottom>
                  {t("account_creation_text")}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  {t("indication_register_text")}
                </Typography>
                {ctrlsDefinitions.length > 0 ? (
                  <DynamicQuestion
                    data={ctrlsDefinitions}
                    clickSubmit={submitRegister}
                  />
                ) : null}
              </FormProvider>
            </DialogContent>
          </Container>
        </Box>
      </Dialog>
    </React.Fragment>
  );
}

const DynamicQuestion = (props) => {
  const { control, handleSubmit, formState, register } = useForm({
    mode: "onBlur",
  });
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {props.data.length > 0 &&
        props.data.map((itemInput, indexInput) => {
          // console.log("formState.errors: ", formState.errors[`${itemInput.Name}`])
          // console.log("itemInput:", activePersonMoral, itemInput)
          switch (itemInput.QuestionType.toUpperCase()) {
            case "PHONE":
              return (
                <InputField
                  inputType="phone"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                  phoneRegular={itemInput?.RegularExpression}
                />
              );
            case "NUMBER":
              return (
                <InputField
                  inputType="number"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
              );
            case "CLABE":
              return (
                <InputField
                  inputType="clabe"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
              );
            case "EMAIL":
              return (
                <InputField
                  inputType="email"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
              );
            case "RADIO":
              return (
                <InputField
                  inputType="radio"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  radioValues={itemInput.Options}
                  required={itemInput.Required}
                  validations={{ required: true }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                />
              );
            case "COMBO":
              return (
                <InputField
                  inputType="select"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  optionsList={itemInput.Options}
                  validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
              );
            case "AUTOCOMPLETE":
              return (
                <InputField
                  inputType="autocomplete"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Description}
                  placeholder={itemInput.Description}
                  defaultValue={itemInput.Value}
                  optionsList={itemInput.Options}
                  validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                  //onClose={(e) => console.log("looog", e)}
                  /* onSelect={(e) => {
                    console.log("....AUTOCOMPLETE COMBO e: ", e);
                    setValue(`${itemInput.Id}`, e);
                    UpdateCtrlQuestions(itemInput, "");
                  }} */
                  /* onInputChange={(e, searchValue) => {
                    console.log("--*-----autocomplete------e.....", e?.type, e);
                  }} */
                />
              );
            case "FECHA":
              return (
                <InputField
                  inputType="date"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
              );
            case "FECHAPREVIA":
              return (
                <InputField
                  inputType="date"
                  control={control}
                  register={register}
                  maxDate={new Date()}
                  name={`${itemInput.Name}`}
                  label={itemInput.Description}
                  validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                  disabled={itemInput.Disabled}
                />
              );
            case "CURRENCY":
              return (
                <InputField
                  inputType="currency"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
              );
            case "PASSWORD":
              return (
                <InputField
                  inputType="password"
                  isPassword={true}
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  // validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
              );
            case "CHECKBOX":
              return (
                <InputField
                  inputType="check"
                  control={control}
                  name={`${itemInput.Name}`}
                  label={itemInput.Label}
                  radioValues={itemInput.Options}
                  required={itemInput.Required}
                  validations={{ required: true }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                />
              );
            case "CAPTCHA":
              return null;
            default:
              return (
                <InputField
                  inputType="text"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  validations={{ required: itemInput.Required }}
                  defaultValue={itemInput.Value}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
              );
          }
        })}
      <Buttons
        //disabledConfirm={!props.activeButton}
        onClickConfirm={handleSubmit(props.clickSubmit)}
        marginBottom={75}
        ConfirmButtonText={t("register_text")}
      />
    </Box>
  );
};
